"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("@ikea-aoa/enums");
/**
 * This class is used for transforming data from IRW into the format of the StoreAvailability model.
 */
var IowsStoreAvailabilityListTransformer = /** @class */ (function () {
    function IowsStoreAvailabilityListTransformer() {
    }
    /**
     * Transforms data into format of StoreAvailability model.
     *
     * @param inputData Data to parse.
     * @param inputData.StockAvailabilityList
     * @returns Parsed data.
     */
    IowsStoreAvailabilityListTransformer.prototype.transform = function (inputData) {
        var _this = this;
        var _a;
        var data = (_a = inputData.StockAvailabilityList) === null || _a === void 0 ? void 0 : _a.StockAvailability;
        if (!data) {
            return [];
        }
        if (Array.isArray(data)) {
            return data.map(function (item) { return _this.getStoreAvailability(item); });
        }
        return [this.getStoreAvailability(data)];
    };
    /**
     * @param item
     */
    IowsStoreAvailabilityListTransformer.prototype.getStoreAvailability = function (item) {
        return {
            id: this.getItemNo(item),
            type: this.getItemType(item),
            stockAvailability: this.getStockAvailability(item),
            inStockProbabilityCode: this.getInStockProbabilityCode(item),
            salesLocation: this.getSalesLocation(item === null || item === void 0 ? void 0 : item.RetailItemAvailability),
            salesMethodCode: this.getSalesMethodCode(item === null || item === void 0 ? void 0 : item.RetailItemAvailability),
            children: this.getChildren(item)
        };
    };
    /**
     * Returns children.
     *
     * @param item
     * @returns Children.
     */
    IowsStoreAvailabilityListTransformer.prototype.getChildren = function (item) {
        var _this = this;
        var _a, _b;
        var itemType = this.getItemType(item);
        if (itemType === 'SPR') {
            var childAvailability = ((_b = (_a = item === null || item === void 0 ? void 0 : item.RetailItemAvailability) === null || _a === void 0 ? void 0 : _a.RetailItemCommChildAvailabilityList) === null || _b === void 0 ? void 0 : _b.RetailItemCommChildAvailability) || [];
            if (Array.isArray(childAvailability)) {
                return childAvailability.map(function (child) { return _this.getChildItem(child); });
            }
            else {
                // This should not happen. An SPR should have more than one child
                return [this.getChildItem(childAvailability)];
            }
        }
        return [];
    };
    /**
     * Returns child item availability.
     *
     * @param availability
     * @returns Child item availability data.
     */
    IowsStoreAvailabilityListTransformer.prototype.getChildItem = function (availability) {
        var _a, _b;
        var salesMethodCode = this.getSalesMethodCode(availability);
        return {
            id: String((_a = availability === null || availability === void 0 ? void 0 : availability.ItemNo) === null || _a === void 0 ? void 0 : _a.$),
            type: (_b = availability === null || availability === void 0 ? void 0 : availability.ItemType) === null || _b === void 0 ? void 0 : _b.$,
            salesLocation: this.getSalesLocation(availability),
            salesMethodCode: salesMethodCode
        };
    };
    /**
     * Returns item type.
     *
     * @param item
     * @returns Item type.
     */
    IowsStoreAvailabilityListTransformer.prototype.getItemType = function (item) {
        var _a, _b;
        return ((_b = (_a = item === null || item === void 0 ? void 0 : item.ItemKey) === null || _a === void 0 ? void 0 : _a.ItemType) === null || _b === void 0 ? void 0 : _b.$) || null;
    };
    /**
     * Returns in stock probability code.
     *
     * @param item
     * @returns Item type.
     */
    IowsStoreAvailabilityListTransformer.prototype.getInStockProbabilityCode = function (item) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.RetailItemAvailability) === null || _a === void 0 ? void 0 : _a.InStockProbabilityCode) === null || _b === void 0 ? void 0 : _b.$) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || null;
    };
    /**
     * Returns stock availability.
     *
     * @param item
     * @returns Item type.
     */
    IowsStoreAvailabilityListTransformer.prototype.getStockAvailability = function (item) {
        var _a, _b;
        var unformatted = (_b = (_a = item === null || item === void 0 ? void 0 : item.RetailItemAvailability) === null || _a === void 0 ? void 0 : _a.AvailableStock) === null || _b === void 0 ? void 0 : _b.$;
        if (!unformatted) {
            return null;
        }
        return Number(unformatted);
    };
    /**
     * Returns item number.
     *
     * @param item
     * @returns Item type.
     */
    IowsStoreAvailabilityListTransformer.prototype.getItemNo = function (item) {
        var _a, _b;
        var unformatted = (_b = (_a = item === null || item === void 0 ? void 0 : item.ItemKey) === null || _a === void 0 ? void 0 : _a.ItemNo) === null || _b === void 0 ? void 0 : _b.$;
        if (!unformatted) {
            return null;
        }
        return String(unformatted);
    };
    /**
     * Applies code and location to availability data object.
     *
     * @param availability
     * @returns Sales method code.
     */
    IowsStoreAvailabilityListTransformer.prototype.getSalesMethodCode = function (availability) {
        var _a;
        var salesMethodCode = ((_a = availability === null || availability === void 0 ? void 0 : availability.SalesMethodCode) === null || _a === void 0 ? void 0 : _a.$) || null;
        if (salesMethodCode) {
            switch (Number(salesMethodCode)) {
                case 0:
                    return enums_1.SalesMethodCodeEnum.satellite;
                case 1:
                    return enums_1.SalesMethodCodeEnum.selfServe;
                case 2:
                    return enums_1.SalesMethodCodeEnum.fullServe; // Contact co-worker
                case 3:
                    return enums_1.SalesMethodCodeEnum.dds; // Contact co-worker
            }
        }
        return null;
    };
    /**
     * Returns sales location.
     *
     * @param availability Data object.
     * @returns Sales location object.
     */
    IowsStoreAvailabilityListTransformer.prototype.getSalesLocation = function (availability) {
        var _a;
        var unformattedLocation = (_a = availability === null || availability === void 0 ? void 0 : availability.RecommendedSalesLocation) === null || _a === void 0 ? void 0 : _a.$;
        var location = unformattedLocation ? String(unformattedLocation) : null;
        var salesMethodCode = this.getSalesMethodCode(availability);
        if (salesMethodCode === enums_1.SalesMethodCodeEnum.satellite && location) {
            return { aisle: null, bin: null, department: location };
        }
        else if (salesMethodCode === enums_1.SalesMethodCodeEnum.selfServe && location) {
            if (!isNaN(Number(location)) && location.length === 6) {
                return {
                    aisle: location.substr(0, 2),
                    bin: location.substr(2, 2),
                    department: null
                };
            }
            if (location.length === 3 && !isNaN(Number(location.substr(0, 2)))) {
                return {
                    aisle: location.substr(0, 2),
                    bin: location.substr(2, 1),
                    department: null
                };
            }
        }
        return null;
    };
    return IowsStoreAvailabilityListTransformer;
}());
exports.default = IowsStoreAvailabilityListTransformer;
//# sourceMappingURL=IowsStoreAvailabilityListTransformer.js.map